module.exports = __webpack_public_path__ + "img/retail_mobile.d98591c5.jpg";